export default __webpack_public_path__ + "static/media/IMG-20241210-WA0027.e9714509.jpg";